import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { displayResource, Resource } from "features/resources/resource";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    resource: null,
    color: null
  },
  setup(__props: any) {

const props = __props as {
    resource: Resource;
    color: string;
}



const amount = computed(() => displayResource(props.resource));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h2", {
    style: _normalizeStyle({ color: __props.color, 'text-shadow': '0px 0px 10px ' + __props.color })
  }, _toDisplayString(_unref(amount)), 5))
}
}

})